import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RootLayoutComponent } from './root-layout.component';
import { ToastContainerComponent } from '@core/toast/components/toast-container.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RootLayoutComponent, ToastContainerComponent],
  template: `
    <app-root-layout />
    <app-toast-container />
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: block;
        height: 100%;
      }
    `,
  ],
})
export class RootComponent {}
